import React, { useState } from "react";
import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";
import Loading from "carbon-components-react/lib/components/Loading";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import RotatableImage from "../../components/rotatableImage";

export default function QuestionView(props) {
  const { t, i18n } = useTranslation("kunduz");

  function getFormattedCreatedTime() {
    const { question } = props;
    if (question && question.created) {
      const formatted = dayjs(question.created).diff(new Date(), "minute") * -1;
      return `${formatted} ${t("minutesAgo")}`;
    } else {
      return "";
    }
  }

  const { question, preview } = props;
  return (
    <div className="">
      {props.inProgress ? <Loading withOverlay={true} /> : null}
      <div className="flex-line flex-jcsb flex-aic">
        <span className="answer-title">
          {t(preview ? "question" : "questionToMatch")}
        </span>
        <span className="answer-secondary">
          {preview ? null : getFormattedCreatedTime()}
        </span>
      </div>

      <div
        className="flex-line flex-jcsb flex-aic"
        style={{ marginTop: "16px" }}
      >
        <span className="answer-title2">
          {question && question.course ? question.course : "N/A"}
        </span>
        <span className="answer-title2">#{question ? question.id : ""}</span>
      </div>

      {question ? <RotatableImage src={question.media.original} side={props.side} /> : null}
    </div>
  );
}
